import { supabase } from './supabaseClient';

export const DEFAULT_VAPID_PUBLIC_KEY =
  process.env.REACT_APP_VAPID_PUBLIC_KEY ||
  'BH6wDS8DSCDSL6xFW1XIJcWaOwg0yJoGbSCbT1GZ8sKzS4A74cJPNEtq-hQqZEsuYwVel_BY2PsIlL3trxTXlbU';

/**
 * Converts a base64 string to a Uint8Array for pushManager.subscribe()
 */
export function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function isPushSupported() {
  return (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}

export function getPushPermissionStatus() {
  if (!isPushSupported()) return 'unsupported';
  return Notification.permission;
}

/**
 * Subscribe current device to Web Push and record the subscription in Supabase.
 */
export async function subscribeToPush(userId) {
  if (!isPushSupported()) {
    throw new Error('Ky shfletues nuk mbështet njoftimet push.');
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Nuk u dha leja për njoftime në shfletues.');
  }

  const registration = await navigator.serviceWorker.ready;
  if (!registration.pushManager) {
    throw new Error('PushManager nuk është i disponueshëm në këtë shfletues.');
  }

  let subscription = await registration.pushManager.getSubscription();

  if (!subscription) {
    const convertedKey = urlBase64ToUint8Array(DEFAULT_VAPID_PUBLIC_KEY);
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: convertedKey,
    });
  }

  const subJson = subscription.toJSON();
  const endpoint = subscription.endpoint;
  const p256dh = subJson.keys?.p256dh;
  const auth = subJson.keys?.auth;

  if (!endpoint || !p256dh || !auth) {
    throw new Error('Dështoi krijimi i çelësave të pajtimit push.');
  }

  if (userId) {
    const { error } = await supabase.from('push_subscriptions').upsert(
      {
        user_id: userId,
        endpoint,
        p256dh,
        auth,
        user_agent: (navigator.userAgent || '').slice(0, 255),
      },
      { onConflict: 'endpoint' }
    );

    if (error) {
      console.warn('Unable to persist push subscription in Supabase:', error);
    }
  }

  localStorage.setItem('app_desktop_notifications', 'true');
  return subscription;
}

/**
 * Unsubscribe current device from Web Push and remove record from Supabase.
 */
export async function unsubscribeFromPush(userId) {
  if (!isPushSupported()) return false;

  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();

    if (subscription) {
      const endpoint = subscription.endpoint;

      if (userId) {
        await supabase
          .from('push_subscriptions')
          .delete()
          .eq('endpoint', endpoint);
      }

      await subscription.unsubscribe();
    }

    localStorage.setItem('app_desktop_notifications', 'false');
    return true;
  } catch (error) {
    console.error('Error during unsubscribeFromPush:', error);
    return false;
  }
}
